import React from 'react';

const CellPriceWithCurrency = ({price, currencyMap}) => {

    return (
        <div>
            {price != null && price.price != null && price.currency != null ? (
                <span>
                  {price.price} {currencyMap.get(price.currencyId).curAbbreviation}
                </span>) : ('')}
        </div>
    );
};

export default CellPriceWithCurrency;

